import React from 'react';

import { Flex, Text } from '@chakra-ui/react';

export default function UserAssignHeader() {
  return (
    <Flex
      justifyContent="space-between"
      width="100%">
      <Text variant="xLargeBold">Condutores vinculados</Text>
    </Flex>
  );
}
